import DarkCloser from '@/assets/imgs/dark-closer.svg?react'

import * as S from './styles'

type Props = {
  onClose: () => void
}

const CloseButton = ({ onClose }: Props) => {
  return (
    <S.CustomButton onClick={onClose} data-testid="close-modal-icon">
      <DarkCloser />
    </S.CustomButton>
  )
}

export default CloseButton
